import { useLayoutEffect, useRef } from "react";

const isBrowser = typeof window !== `undefined`;

const getWidth = () => {
  return isBrowser
    ? window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth
    : 0;
};
// Hook
export function useResize(effect, deps, element, useWindow, wait) {
  const position = useRef(getWidth({ useWindow }));

  let throttleTimeout = null;

  const callBack = () => {
    const currPos = getWidth({ element, useWindow });
    effect({ prevPos: position.current, currPos });
    position.current = currPos;
    throttleTimeout = null;
  };

  useLayoutEffect(() => {
    const handleResize = () => {
      if (wait) {
        if (throttleTimeout === null) {
          throttleTimeout = setTimeout(callBack, wait);
        }
      } else {
        callBack();
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, deps);
}
